import React from 'react';

import { angularizeWithProviders } from '../../../../../../shared/providers';
import {
  BodyMetrics,
  getMetrics,
} from '../../../../customer-setup-flow-2024/containers/GoalsStep/utils/getMetrics';
import { BodyMetricsTable } from '../../../../customer-setup-flow-2024/containers/GoalsStep/BodyMetricsTable/BodyMetricsTable';

const NgzBodyCompositionMetrics = ({
  currentMetrics,
  goalMetrics,
}: {
  currentMetrics: BodyMetrics;
  goalMetrics: BodyMetrics;
}) => {
  const metrics = getMetrics(currentMetrics, goalMetrics);

  return <BodyMetricsTable {...metrics} />;
};

angularizeWithProviders(NgzBodyCompositionMetrics, 'ngzBodyCompositionMetrics', {
  currentMetrics: '<',
  goalMetrics: '<',
});

export { NgzBodyCompositionMetrics };
